import { useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_PUBLIC_CRYPT_KEY;

export default function useCourseInstructor() {
  const [instructor, setInstructor] = useState(null);

  useEffect(() => {
    const encryptedInstructor = localStorage.getItem('courseInstructor');
    if (encryptedInstructor && SECRET_KEY) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedInstructor, SECRET_KEY);
        const decryptedInstructor = bytes.toString(CryptoJS.enc.Utf8);

        if (decryptedInstructor) {
          setInstructor(decryptedInstructor);
        } else {
          throw new Error('Decryption returned empty string');
        }
      } catch (err) {
        console.error('Failed to decrypt instructor from localStorage', err);
        localStorage.removeItem('courseInstructor');
      }
    }
  }, []);

  return instructor;
}
